import { observable } from 'mobx';
import gql from 'graphql-tag';
import ApolloClient from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';

// get all deals for rendering
const CollectionQuery = gql`
        query CollectionQuery($ID: Int) {
            readCollections(ID: $ID) {
                ID
                Title
                Description
                URLSegment
                ImageURL
                Link
                Width
                Height
                BackgroundColor
                LogoColor
                Content
                EnableAboutContent
                AboutButtonText
                Artwork(sortBy: [{field: Sort, direction: ASC}]) {
                    edges {
                        node {
                            ID
                            Title
                            URLSegment
                            ImageURL
                            FramedImageURL
                            Link
                            Content
                            Artist
                            Date
                            Medium
                            Size
                            Sort
                            Left
                            Top
                            Width
                            Height
                            HeightPercent
                            WidthPercent
                            TopPercent
                            LeftPercent
                            Orientation
                        }
                    }
                }
            }
        }
    `,
    SettingsQuery = gql`
        query SettingsQuery {
            readSettings {
                GACode,
                Title,
                Wakelock,
                IdleTime,
                ExpressionsIP,
                IsInternal,
            }
        }
    `;

export class AppStore {

    static instance: AppStore;

    @observable collections = [];

    @observable collection = null;

    @observable settings;

    @observable expCollectionID = null;

    @observable aboutOpen = null;

    @observable zoomState = {
        left: '-90%',
        top: '-90%',
        scaleX: 1,
        scaleY: 1,
        animate: false
    };

    @observable carouselOpen = false;

    defaultTitle = 'Expressions';

    getApiUri() {
        let location = window.location.hostname;

        if (location === 'localhost' || location === '10.0.2.2') {
            return '//api.exp-www.test/api/';
        }

        return '//api.' + window.location.hostname + '/api/';
    }

    apolloClient = new ApolloClient({
        link: new HttpLink({ uri: this.getApiUri() }),
        cache: new InMemoryCache().restore(window.__APOLLO_STATE__)
    });

    static getInstance() {
        return AppStore.instance || (AppStore.instance = new AppStore());
    }

    async initializeSettings() {
        const result = await this.apolloClient
            .query({
                query: SettingsQuery,
                variables: {
                    Link: false
                },
                fetchPolicy: 'cache-first'
            })
            .catch(e => {
                this.serverError = true;
                return false;
            });

        if (
            result &&
            result.data.readSettings &&
            result.data.readSettings.length > 0
        ) {
            this.settings = result.data.readSettings[0];
            // console.log('settings', this.settings);
        }
    }

    async initializeCollections() {
        const result = await this.apolloClient.query({
            query: CollectionQuery,
            variables: {
                ID: this.expCollectionID
            },
            fetchPolicy: 'network-only'
        }).catch(e => {
            this.serverError = true;
            return false;
        });

        if (result.data && result.data.readCollections && result.data.readCollections.length > 0) {
            this.setCollections(result.data.readCollections);
        } else {
            this.collections = false;
        }
    }

    /**
     * Set the collections to display
     */
    setCollections(data) {
        let collections = [];

        data.slice().map((item, i) => {
            let collection = {};

            for (let key of Object.keys(item)) {
                collection[key] = item[key];
            };
            collection.Artwork = [];

            if (item.Artwork.edges && item.Artwork.edges.length) {
                item.Artwork.edges.map((edge, j) => {
                    let artwork = {
                        Pos: j
                    };

                    for (let key of Object.keys(edge.node)) {
                        artwork[key] = edge.node[key];
                    };

                    collection.Artwork.push(artwork);
                });
            }

            if (collection.Artwork.length) {
                collections.push(collection);
            }
        });

        this.collections = collections;
        // console.log('Collection loaded ', this.collections.length, this.collections);
    }

}



// WEBPACK FOOTER //
// ./src/_app/app.store.js